export default __webpack_public_path__ + "static/media/edit-icon.5e39abc9.svg";